<template>

    <!-- Modal dialog -->
    <v-dialog persistent :modelValue="display">

        <!-- Close btn -->
        <v-btn class="btn btn--default-fill btn--round btn--sm ml-auto" v-if="showCloseXButton" @click="$emit('modalClosed')">
            <img src="@assets/images/modal/icon-close.svg" alt="Close">
        </v-btn>

        <!-- Dialog title -->
        <div class="dialog__heading">
            {{ title }}
        </div>

        <!-- Dialog body -->
        <div class="dialog__body">
            <slot />
        </div>

        <hr class="hr mb-8">

        <!-- Dialog footer (btns) -->
        <div class="dialog__footer" :class="[btnCenter ? $style.moveCenter : null]">
            <v-btn v-if="showDeclineButton" flat class="btn btn--default-fill" @click="$emit('modalClosed')">{{ closeText }}</v-btn>
            <v-btn v-if="showAcceptButton" flat class="btn btn--primary-fill" @click="$emit('accept')" :disabled="disabledAccept">{{ acceptText }}</v-btn>
        </div>   

    </v-dialog>
    
</template>

<script setup lang="ts">

    defineProps({
        display: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        closeText: {
            type: String,
            default: ''
        },
        acceptText: {
            type: String,
            default: ''
        },
        showCloseXButton: {
            type: Boolean,            
            default: true
        },
        showAcceptButton: {
            type: Boolean,            
            default: true
        },
        showDeclineButton: {
            type: Boolean,
            default: true
        },
        btnCenter: {
            type: Boolean,
            default: false
        },
        disabledAccept: {
            type: Boolean,
            default: false  
        },
        showCloseButton: {
            type: Boolean,            
            default: false
        },
    });  

    defineEmits(['modalClosed', 'accept']);

</script>

<style lang="postcss" module scoped>

    .moveCenter {
        text-align: center;
    }
</style>

